import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng';
import { ImportDataType } from '../../interfaces/data-import/import-data-type';
import { IImportEntry } from '../../interfaces/data-import/import-entry';
import { IImportResult } from '../../interfaces/data-import/import-result';
import { DataImportService, UserService } from '../../services';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'data-import',
  templateUrl: './data-import.component.html',
  styleUrls: ['./data-import.component.css'],
})
export class DataImportComponent implements OnInit {
  invalidEntries: IImportEntry[] = [];
  validEntries: IImportEntry[] = [];
  @Input('importDataType')
  get importDataType() {
    return this._importDataType;
  }
  set importDataType(value: ImportDataType) {
    this._importDataType = value;
  }
  filesSelected: null;

  _importDataType: ImportDataType;
  isUpLoading: boolean = false;

  constructor(
    public dataImportService: DataImportService,
    private confirmationService: ConfirmationService,
    private route: ActivatedRoute,
    private userService: UserService,
  ) {}

  ngOnInit() {
    this._importDataType = <ImportDataType>this.route.snapshot.params['id'] || this._importDataType;
    this.userService.isUserImpersonating().then((res) => {
      var isImpersonating = false;
      if (res != null) {
        isImpersonating = res.isImpersonating;
      } else {
        isImpersonating = false;
      }

      this.dataImportService.loadConfig(this._importDataType, isImpersonating);
    });
  }

  onSelect(event) {
    if (event.files.length > 0) {
      this.filesSelected = event.files;
    }
  }
  onClear(event) {
    this.filesSelected = null;
  }

  onBeforeUpload(event: { xhr: XMLHttpRequest; formData: FormData }): void {
    this.invalidEntries = [];
    this.validEntries = [];
    event.formData.append('config', JSON.stringify(this.dataImportService.config));
    this.isUpLoading = true;
  }

  onUpload(event: { originalEvent: HttpResponse<any>; files: File[] }) {
    let response = event.originalEvent.body as IImportResult;
    let msg: string;
    if (response) {
      if (response.invalidEntries.length) {
        this.invalidEntries = response.invalidEntries;
        msg = 'There are some entries with errors. See "Errors" tab for details';
      } else {
        msg = `${response.importedCount} entries were imported`;
        this.validEntries = response.validEntries;
        this.dataImportService.imported$.emit();
      }
      if (response && response.warning) {
        msg = `<b>${response.warning}!</b> <br/> ${msg}`;
      }
      this.confirmationService.confirm({
        message: msg,
        icon: 'fa fa-info',
        rejectVisible: false,
        acceptLabel: 'Ok',
      });
    }
    this.isUpLoading = false;
  }

  onUploadError(event) {
    const errorDescription = event.originalEvent.body;
    //var errorDescripton = event.xhr.response;

    this.isUpLoading = false;
    this.confirmationService.confirm({
      message: errorDescription,
      key: 'cd',
      rejectVisible: false,
      acceptLabel: 'Ok',
    });
  }

  hideDialog() {
    this.isUpLoading = false;
  }
}
